"use client"

import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { cn } from "@/lib/utils"

const CheckedIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="6" fill="#111827"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M18.0728 6.50666C18.6214 6.87856 18.7646 7.62473 18.3927 8.1733L12.2912 17.1733C12.0919 17.4672 11.7727 17.6578 11.4195 17.6938C11.0662 17.7297 10.7151 17.6074 10.4607 17.3596L5.76222 12.7841C5.28741 12.3218 5.27733 11.562 5.7397 11.0872C6.20208 10.6124 6.96181 10.6024 7.43661 11.0647L11.1087 14.6406L16.4062 6.82655C16.778 6.27799 17.5242 6.13477 18.0728 6.50666Z" fill="white"/>
  </svg>
)

const UncheckedIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" stroke="#D1D5DB"/>
  </svg>
)

const Checkbox = React.forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-6 w-6 shrink-0 rounded-md ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      className
    )}
    {...props}
  >
    {/* Unchecked — shown by default, hidden when checked */}
    <span className="flex items-center justify-center data-[state=checked]:hidden group-data-[state=checked]:hidden peer-data-[state=checked]:hidden [[data-state=checked]_&]:hidden">
      <UncheckedIcon />
    </span>

    {/* Checked — only renders when checked */}
    <CheckboxPrimitive.Indicator className="flex items-center justify-center">
      <CheckedIcon />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
